import axios from 'axios'

const API_URL = process.env.VUE_APP_API_BASE_URL

class DashboardService {
  getTotalRevenueInformation (shopId, duration) {
    shopId = parseInt(shopId) === -1 ? 0 : shopId
    return axios.get(API_URL + 'dashboard/total-revenue/' + shopId + '/' + duration, { showLoader: false })
  }

  getRevenueGrowthInformation (shopId, duration) {
    shopId = parseInt(shopId) === -1 ? 0 : shopId
    return axios.get(API_URL + 'dashboard/revenue-growth/' + shopId + '/' + duration, { showLoader: false })
  }

  getClassSignupInformation (duration) {
    return axios.get(API_URL + 'dashboard/class-signups/' + duration, { showLoader: false })
  }

  getClientCreditInformation (duration) {
    return axios.get(API_URL + 'dashboard/client-credit/' + duration, { showLoader: false })
  }

  getTop3ProductItemsInformation (duration) {
    return axios.get(API_URL + 'dashboard/popular-products/' + duration, { showLoader: false })
  }

  getRentalRevenueGrowthInformation (shopId, duration) {
    return axios.get(API_URL + 'dashboard/rental-revenue-growth/' + shopId + '/' + duration, { showLoader: false })
  }

  getRevenueSourcesInformation (shopId, duration) {
    return axios.get(API_URL + 'dashboard/revenue-sources/' + shopId + '/' + duration, { showLoader: false })
  }

  getTourAndEnrollmentInformation (duration) {
    return axios.get(API_URL + 'dashboard/tour-details/' + duration, { showLoader: false })
  }

  getSupportGroupSignupInformation (duration) {
    return axios.get(API_URL + 'dashboard/sg-signups/' + duration, { showLoader: false })
  }

  getWebinarSignupInformation (duration) {
    return axios.get(API_URL + 'dashboard/webinar-signups/' + duration, { showLoader: false })
  }

  getPortalSetupInformation () {
    return axios.get(API_URL + 'dashboard/portal-setup-status/', { showLoader: false })
  }
}

export default new DashboardService()
